import { FunctionComponent, PropsWithChildren } from 'react';
import { Panel } from '@cbridge-tools/resizable-panels';
import Toolbar from '@mui/material/Toolbar';
import { Classnames } from '@cbridge-utils/mui-theme';

interface INavigationPanelProps {
  /** Hard pixel floor for the panel width (on top of the percentage `minSize`). */
  minWidth?: number;
  /** Percentage floor for the panel width. Defaults to 5. */
  minSize?: number;
}

export const NavigationPanel: FunctionComponent<PropsWithChildren<INavigationPanelProps>> = (props) => {
  const { children, minWidth, minSize = 5 } = props;

  return (
    <Panel
      id={'nav'}
      className={Classnames.CONFIG_NAV_PANEL}
      tagName={'nav'}
      defaultSize={10}
      minSize={minSize}
      maxSize={25}
      style={minWidth ? { minWidth } : undefined}
    >
      <Toolbar />
      {children}
    </Panel>
  );
};
